import { EntityId } from "@reduxjs/toolkit"
import { createContext, useContext } from "react"

export const CurrentPageIdContext = createContext<{ id: EntityId }>({ id: 0 })

export const useCurrentPageId = () => {
  const context = useContext(CurrentPageIdContext)
  return context.id
}
